import React, { useState, useEffect } from "react";
import { Paginator } from "../../../layout/Paginator/Paginator";
import { Search } from "../../../layout/Table/Search";
import { TableComponent } from "../../organizations/table/Table";
import { Messages } from "../../../../components/layout/Messages/Messages";
import { ACL } from '../../../../config/constants';
import { RowsPerPage } from "../../../layout/Table/RowsPerPage";
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';
import { ListToolbar } from '../../../layout/Workspace';

function ClientOrganizationsTab(props) {
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const {user, getUserOrganizations, organizations, metaOrganizations, rowsPerPageOrganizations, setRowsPerPageOrganizations} = props;
  const shouldRenderFields = false;

  useEffect( () => {
    if (user && getUserOrganizations) {
      getUserOrganizations(user.id, 1, sortField, sortDirection, searchText);
    }

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPageOrganizations] );

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField(appliedSortField);
    setSortDirection(newSortDirection);

    getUserOrganizations(user.id, metaOrganizations.current_page, appliedSortField, newSortDirection, searchText, true);
  }

  return (
    <section className="user-detail-section">
      <div className="user-detail-section__messages">
        <Messages/>
      </div>
      <ListToolbar
        className="user-detail-list-toolbar"
        search={ACL.CLIENT.USERS.SEARCH.hasAccess() ? (
          <Search
              search={(searchText) => {
                setSearchText(searchText);
                getUserOrganizations(user.id, 1, null, null, searchText, true);
              }}
              id="organizations"
          />
        ) : null}
      />
      <div className="user-detail-table">
        <TableComponent
          shouldRenderFields={shouldRenderFields}
          applySort={(sortField) => applySort(sortField)}
          organizations={organizations}
          actionCallback={(useState) => {
            if (useState) {
              getUserOrganizations(
                user.id,
                metaOrganizations.current_page,
                sortField,
                sortDirection,
                searchText
              );
            }
            getUserOrganizations(user.id);
          }}
        />
      </div>
      <Paginator
        meta={metaOrganizations}
        settings={(
          <RowsPerPage
            changeRowsPerPage={(rowsPerPage) => {
              setRowsPerPageOrganizations(rowsPerPage);
            }}
            id="organizations"
          />
        )}
        changePage={(page) =>
          getUserOrganizations(user.id, page, sortField, sortDirection, searchText, true)
        }
      />
    </section>
  );
}

export { ClientOrganizationsTab };
